'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosInfinite = function IoIosInfinite(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 14.2c1.6 1.6 2.5 3.6 2.5 5.8s-0.9 4.2-2.5 5.8-3.7 2.3-5.9 2.3-4.3-0.8-5.9-2.3l-9.7-9.6c-1.1-1-2.5-1.6-4-1.6s-2.9 0.6-3.9 1.6-1.7 2.4-1.7 3.8c0 1.5 0.7 2.8 1.7 3.8s2.4 1.6 3.9 1.6 3-0.6 4-1.6l3-2.9 2 1.9-3.1 3c-1.5 1.5-3.7 2.3-5.9 2.3s-4.3-0.8-5.9-2.3-2.4-3.6-2.4-5.8 0.9-4.2 2.4-5.8 3.7-2.3 5.9-2.3 4.4 0.8 5.9 2.3l9.8 9.6c1 1 2.4 1.6 3.9 1.6s3-0.6 4-1.6 1.5-2.4 1.5-3.8c0-1.5-0.5-2.8-1.5-3.8s-2.5-1.6-4-1.6-2.9 0.6-3.9 1.6l-3.1 2.9-1.9-1.9 3-3c1.6-1.5 3.8-2.3 6-2.3s4.3 0.8 5.8 2.3z' })
        )
    );
};

exports.default = IoIosInfinite;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-infinite.js
// module id = 2421
// module chunks = 0